module.exports = __webpack_public_path__ + "img/link.b34510d8.svg";